import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { ItemCard } from '../../../components/atoms/ItemCard';
import { ItemCardField } from '../../../components/atoms/ItemCardField';
import { SentToAadeIcon } from '../../../components/atoms/SentToAadeIcon';
import { TypePill } from '../../../components/atoms/TypePill';
import { CloneEntityButton } from '../../../components/molecules/CloneEntityButton';
import { CorrelateEntityButton } from '../../../components/molecules/CorrelateEntityButton';
import { getLocalDate } from '../../../config/utils/dateHelpers';
import { CURRENCY } from '../../../interfaces/enumerables';
import { InvoiceInList } from '../../../interfaces/invoice.interface';
import { PATHS } from '../../../navigation/data';

interface Props {
  index: number;
  data: InvoiceInList;
  showCorrelateButton?: boolean;
}

export const SalesItemCard = ({ index, data, showCorrelateButton = true }: Props) => {
  const { t } = useTranslation();
  const currencySymbol = useMemo(() => CURRENCY[data?.currency || 'EUR'], [data?.currency]);

  const getDate = useCallback(() => {
    return getLocalDate(data?.documentDate);
  }, [data]);

  const getTypePill = useCallback(() => {
    let textClass = '';
    if (data?.post_with_provider) {
      textClass = 'text-blue';
    }

    return <TypePill type={t(`DOC_TYPES.${data?.documentType?.name}`)} textClass={textClass} />;
  }, [data?.documentType?.name, data?.post_with_provider, t]);

  return (
    <div className="width-100 itemOfList positionRelative">
      <ItemCard
        index={index}
        routerLink={`${PATHS.SALES}/view/${data.id}`}
        entityId={`${data.seriesName}-${data.serialNumber}`}>
        <>
          {getTypePill()}
          <SentToAadeIcon data={data} />
          <div className="flex-space-between-center-row-wrap width-100">
            <ItemCardField classes="margin-r-24" width="width-180px" value={data?.customer?.companyName} />
            <ItemCardField classes="margin-r-24" width="width-180px" value={`${data?.totalValue} ${currencySymbol}`} />
            <ItemCardField classes="margin-r-24" width="width-180px" value={getDate()} />
          </div>
        </>
      </ItemCard>
      {showCorrelateButton && data.mark && <CorrelateEntityButton index={index} data={{ id: data.id }} />}
      <CloneEntityButton index={index} data={{ id: data.id }} path={PATHS.CLONE_SALE} />
    </div>
  );
};
